import React, { createRef, useState } from "react";
import styled from "styled-components";
import {
  RadioButtonGroup,
  Item,
} from "@zebra-fed/zds-react-desktop";
import {useTranslation} from "react-i18next";

const StyledLabel = styled.label`
  color: #4c4c4c;
  background-color: ${(props) => (props.dragging ? "#E1E1E1" : "#F5F5F5")};
  border: dashed 1px #8e8e8e;
  height: 240px;
  width: 1066px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 20px;
  width: calc(100% - 40px);

  &:hover {
    background-color: #e1e1e1;
    cursor: pointer;
  }

  input {
    display: none;
  }

  h1 {
    font-size: 1.25rem;
  }
`;

const TopSection = styled.div`
  display: flex;
  margin-top: 0;
  justify-content: space-between;
  width: 96%;
`;

const StyledHeader = styled.h1`
  font-size: 20px;
  color: #007ABA;
  margin-left: 10px;
`;

export default function UploadBox(props) {
  const radioRef = createRef();
  const fileInputRef = createRef();
  const [dragState, setDragState] = useState("");
  const {t} = useTranslation()

  const listFileTypesUI = () => {
    if (props.accept) {
      return props.accept.map((x, i) => {
        if (i === props.accept.length - 2) {
          return x + " or ";
        } else if (i === props.accept.length - 1) {
          return x;
        } else {
          return x + ", ";
        }
      });
    }
    return "";
  };

  const handleDragOther = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    setDragState("dragging");
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let files = Array.from(e.dataTransfer.files).filter((file) => {
      return fileNameCheck(file.name);
    });
    returnFiles(files);
  };

  const fileNameCheck = (fileName) => {
    if (!fileName) return false;
    for (let i = 0; i < props.accept.length; i++) {
      if (fileName.endsWith(props.accept[i])) {
        return true;
      }
    }
    return false;
  };

  const returnFiles = (files) => {
    props.onDrop(files);
  };

  let listFileTypesUIStr = listFileTypesUI()

  return (
    <>
      <TopSection>
        <StyledHeader>{props.title}</StyledHeader>
      </TopSection>

      <RadioButtonGroup
          key="radbutgrp"
          ref={radioRef}
          name="group1"
          disabled={false}
          align="left"
      >
        <Item key="0" defaultChecked={true}>{t('appendOrFirstTimeUpload')}</Item>
        <Item key="1"> {t('overwriteAllDuplicates')}</Item>
        <Item key="2"> {t('replaceEntireDatabase')}</Item>
      </RadioButtonGroup>
      <StyledLabel
        htmlFor="file"
        onDrop={(e) => handleDrop(e)}
        onDragOver={(e) => handleDragOther(e)}
        onDragEnter={(e) => handleDragOther(e)}
        onDragLeave={(e) => handleDragLeave(e)}
        dragging={dragState}
      >
        <h1 style={{ margin: "0" }}>
          {t('uploadOrDragFileHeader',{listFileTypesUIStr})}
        </h1>
        <p>{props.subtitle}</p>
        <input
          type="file"
          ref={fileInputRef}
          id="file"
          disabled={props.disabled != null ? props.disabled : false}
          accept={props.accept != null ? props.accept.join(",") : ""}
          onChange={() => returnFiles(fileInputRef.current.files)}
          multiple={props.multiple != null ? props.multiple : true}
        ></input>
      </StyledLabel>
    </>
  );
}
